import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { DomSanitizer } from '@angular/platform-browser';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-add-instance',
  templateUrl: './add-instance.component.html',
  styleUrls: ['./add-instance.component.scss'],
})
export class AddInstanceComponent implements OnInit {

  constructor(
    private formBuilder: UntypedFormBuilder,
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    private sanitizer: DomSanitizer,
    public helperService: HelperService, 
    private nav: NavController) { }
  breadcrumbList = [
    {
      label: 'Instance',
      url: '/baseapp/instances'
    },
    {
      label: 'Add',
      embedurl: false,
      url: '/baseapp/instances/add'
    }
  ];
  addInstanceForm: UntypedFormGroup;
  hide: boolean = true;
  hide1200: boolean = false;
  userIp;
  is_default=0;
  connectionFile;
  profileImagePath;
  ngOnInit() {
    
    this.addInstanceForm = this.formBuilder.group({
      instance: ['', Validators.required],
      ip_address: ['', Validators.required],
      username: ['', Validators.required],
      passphrase: ['', Validators.required],
      connection_key: ['', Validators.required],
      is_default: ['0', Validators.required],
      hostname: ['', Validators.required],
      ssh_port: ['', Validators.required],
      port_range_from: ['7001', Validators.required],
      port_range_to: ['7050', Validators.required]
    });
    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });
    this.getUserIp();
    this.getStorage().then((res) => {
      if(res.role_id != 1){
        this.nav.navigateRoot(['baseapp/notauthorized']);
      }
    })
  }
  getUserIp() {
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
      })
  }
  onSubmit() {
    if (this.addInstanceForm.invalid) {
      this.helperService.presentToast("Form incomplete", 2000);
      return;
    }else if(this.connectionFile == undefined || this.connectionFile == ""){
      this.helperService.presentToast("Form incomplete", 2000);
      return;
    }
    this.helperService.loader();
    this.getStorage().then((res) => {
      
      //console.log(this.addInstanceForm.value.connection_key);
      const form: FormData = new FormData();
      //console.log(this.connectionFile);
      // const formData: FormData = new FormData();
      form.append("instance", this.addInstanceForm.value.instance);
      form.append("ip_address", this.addInstanceForm.value.ip_address);
      form.append("username", this.addInstanceForm.value.username);
      form.append("passphrase", this.addInstanceForm.value.passphrase);
      form.append("connection_key", this.connectionFile, this.connectionFile.name);
      form.append("is_default", this.addInstanceForm.value.is_default);
      form.append("hostname", this.addInstanceForm.value.hostname);
      form.append("ssh_port", this.addInstanceForm.value.ssh_port);
      form.append("port_range_from", this.addInstanceForm.value.port_range_from);
      form.append("port_range_to", this.addInstanceForm.value.port_range_to);
      // let payload = this.addInstanceForm.value;
      this.backendService.PostInstanceAPICall('createInstance', form, res.token).subscribe(
        (data1) => {
          
          this.helperService.closeLoader();
          this.helperService.presentToast(data1.msg, 2000);
          this.router.navigate(['/baseapp/instances']);
        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }
  isDefaultToggle(event){
    let value = event.value;
    //console.log(value);
    this.is_default = value;
    this.addInstanceForm.controls['is_default'].setValue(value);
  }
  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      role_id: await this.storage.get("role_id"),
    }
    return data;
  }
  file_store: FileList;
  upload(event){
    // let file: File[];
    // //console.log(event[0].name);
    // this.addInstanceForm.controls['connection_key'].setValue(event[0].name);
    // this.connectionFile = event[0];//Array.from(file).forEach(f => formData.append('file', f));
    if(event.target.files[0].name.split(".")[1] == "pem"){
      this.connectionFile = event.target.files[0];//Array.from(file).forEach(f => formData.append('file', f));
    }else{
      this.helperService.presentToast("Please upload ssh key file", 2000);
    }
  }
}
